// extracted by mini-css-extract-plugin
export default {"mask":"loadMask_mask__TY02p","global":"loadMask_global__0wYVb"};